import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Look up a redirect for the given pathname and act on it.
 *
 * - 301/302  -> performs window.location.replace(to_path) and returns 'redirected'
 * - 404/410  -> returns 'gone' (caller should render the NotFound page)
 * - no match -> returns 'none'
 *
 * Any network error resolves to 'none' so the caller can fall back gracefully.
 */
export async function resolveRedirect(pathname) {
  const alias = (pathname || '').replace(/^\//, '');
  try {
    const { data } = await axios.get(`${API_BASE}/redirects/check`, { params: { path: alias } });
    if (data && data.redirect) {
      const status = data.status_code || 301;
      if (status === 404 || status === 410) {
        return 'gone';
      }
      if (data.to_path) {
        window.location.replace(data.to_path);
        return 'redirected';
      }
    }
  } catch (_) {
    /* ignore — treat as no redirect */
  }
  return 'none';
}
